export default __webpack_public_path__ + "static/media/system_01_02.144595d8.jpg";